import api from './api';

const creditNoteService = {
  getAll: async (params = {}) => {
    const response = await api.get('/credit-notes', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/credit-notes/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/credit-notes', data);
    return response.data;
  },

  confirm: async (id) => {
    const response = await api.put(`/credit-notes/${id}/confirm`);
    return response.data;
  },

  cancel: async (id, reason) => {
    const response = await api.put(`/credit-notes/${id}/cancel`, { reason });
    return response.data;
  },

  getAvailableItems: async (orderId) => {
    const response = await api.get(`/credit-notes/order/${orderId}/items`);
    return response.data;
  },

  getSummary: async (params = {}) => {
    const response = await api.get('/credit-notes/summary', { params });
    return response.data;
  },

  print: async (id, format = 'html') => {
    const response = await api.get(`/credit-notes/${id}/print?format=${format}`, { responseType: 'text' });
    return response.data;
  },
};

export default creditNoteService;
